// extracted by mini-css-extract-plugin
export var icon = "_3x-1";
export var subtext = "_3x-0";